import React, { Component } from 'react'
// import { } from 'react-router-dom';
// import paypal from '../../common/img/paypal.svg';
import { connect } from 'react-redux'
import { Spinner } from 'components/Loaders/Loaders'
import {
  GET_PAYPAL_TOKEN,
  GET_ACCESSIDLOC_TOKEN,
  GET_ACCESSIDCC_TOKEN,
  POST_PAYMENT,
  BASE_URL,
  BYPASS_PAYMENT,
  GET_AVAILABLE_PAYMENT_METHODS,
  GET_PAYROC_CUSTOMER,
  CREATE_PAYROC_TRANSACTION,
  CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE,
  DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE,
  GET_WEB_USER_ACTIVE_CART,
  GET_WEB_CART_BY_REF_NUM,
  GET_APP_SETTING_BY_NAME,
  REMOVE_FROM_WEB_CART_BY_GUID,
  WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR
} from 'requests'
import { setCartQuantity } from '../../actions'
import { calculateReceiptItemsTotal, calculateReceiptItemContainersTotal } from 'utilities'
import LockIcon from '@tecuity/sos-icons/react/lock-solid'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import CreditCardIcon from '@tecuity/sos-icons/react/credit-card-solid'
import BankIcon from '@tecuity/sos-icons/react/bank-solid'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import TrashIcon from '@tecuity/sos-icons/react/trash'
import CaretLeftIcon from '@tecuity/sos-icons/react/caret-left'
import { history } from '../../store'
import { RadioInput } from '../Wizard2/fieldComponents/Form'
import { ConfirmDialog } from 'components/Modal/Modal'
import Portal from 'components/Portal/Portal'
import { FrequentPayorCheckoutSection } from '../FrequentPayor/FrequentPayor'
import {
  ElavonCheckoutSection,
  ElavonProvider,
  submitElavonCheckout
} from 'components/Elavon/Elavon'
import NativeCheckout from './NativeCheckout'
import './Checkout.scss'
import ReactMarkdown from '../../components/Markdown/Markdown'
import { WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR } from '../../requests'

const PAYMENT_METHODS = process.env.PAYMENT_METHODS
const PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK =
  process.env.PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK
const SHOPPING_CART = process.env.SHOPPING_CART
const CHECKOUT_DISCLAIMER = process.env.CHECKOUT_DISCLAIMER
const PASS_ITEM_GUIDS_ON_CHECKOUT = process.env.PASS_ITEM_GUIDS_ON_CHECKOUT

class ConnectedCheckout extends Component {
  constructor() {
    super()
    this.state = {
      paymentSuccessful: false,
      loading: true,
      SECURETOKEN: '',
      SECURETOKENID: '',
      BASEPAYMENTURL: '',
      availableMethods: null
    }
  }
  componentDidMount = () => {
    this.getAvailablePaymentMethods()
  }
  getAvailablePaymentMethods = () => {
    if (!this.props.availableMethods) {
      GET_AVAILABLE_PAYMENT_METHODS(
        this.props.refNum,
        availableMethods => {
          this.setState({ availableMethods, loading: false })
        },
        err => {
          this.setState({ loading: false })
        }
      )
    } else {
      this.setState({ loading: false, availableMethods: this.props.availableMethods })
    }
  }
  payWithCreditCard = () => {
    POST_PAYMENT(
      {
        amendmentNum: this.props.amendmentNum,
        formDefinitionId: this.props.formDefinitionId,
        correctionMode: this.props.correctionMode || false
      },
      this.props.category,
      response => {
        this.props.redirectToReceipt(0)
      }
    )
  }
  render() {
    const {
      cancelCheckout,
      receiptItems = [],
      receiptItemContainers,
      refNum,
      redirectToReceipt,
      ignoreAvailability,
      onReceiptItemContainerRemoved,
      setCartQuantity,
      skipCartQuantityUpdate,
      onCartRefresh
    } = this.props
    const total = receiptItemContainers
      ? calculateReceiptItemContainersTotal(receiptItemContainers)
      : calculateReceiptItemsTotal(receiptItems)

    return (
      <Checkout
        onRequestModalClose={cancelCheckout}
        receiptItems={receiptItems}
        receiptItemContainers={receiptItemContainers}
        total={total}
        refNum={refNum}
        payWithCreditCard={this.payWithCreditCard}
        redirectToReceipt={(refNum) => {
          redirectToReceipt(refNum)
          if (!skipCartQuantityUpdate) {
            setCartQuantity(0)
          }
        }}
        loading={this.state.loading}
        methods={PAYMENT_METHODS}
        availableMethods={this.state.availableMethods}
        ignoreAvailability={ignoreAvailability}
        onReceiptItemContainerRemoved={onReceiptItemContainerRemoved}
        onCartRefresh={onCartRefresh}
      />
    )
  }
}

export default connect(
  null,
  { setCartQuantity }
)(ConnectedCheckout)

export class Checkout extends React.Component {
  state = {
    paymentClicked: false,
    paypalParams: { SECURETOKEN: '', SECURETOKENID: '', BASEPAYMENTURL: '', PAYMENT_URL: '' },
    prePaymentError: false,
    prePaymentErrorMessage: null,
    iTransactIsLoaded: true,
    isAddingFrequentPayorFunds: false,
    deletedGuids: [],
    nativeCheckoutActive: false,
    nativeError: null
  }
  getPaypalToken = () => {
    GET_PAYPAL_TOKEN(
      this.props.refNum,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL, PAYMENT_URL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL,
              PAYMENT_URL
            }
          },
          () => {
            this.paypalSubmit.click()
          }
        )
      },
      err => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message
        })
      }
    )
  }
  getAccessIDCCToken = () => {
    GET_ACCESSIDCC_TOKEN(
      this.props.refNum,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL
            }
          },
          () => {
            this.accessIDCCSubmit.click()
          }
        )
      },
      err => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message
        })
      }
    )
  }
  getAccessIDLOCToken = () => {
    GET_ACCESSIDLOC_TOKEN(
      this.props.refNum,
      ({ SECURETOKEN, SECURETOKENID, BASEPAYMENTURL }) => {
        this.setState(
          {
            paypalParams: {
              SECURETOKEN,
              SECURETOKENID,
              BASEPAYMENTURL
            }
          },
          () => {
            this.accessIDLOCSubmit.click()
          }
        )
      },
      err => {
        this.setState({
          prePaymentError: true,
          paymentClicked: false,
          prePaymentErrorMessage: err.message
        })
      }
    )
  }
  submitElavonCheckout = values => {
    submitElavonCheckout(
      values, 
      PASS_ITEM_GUIDS_ON_CHECKOUT ? this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(container => container.GUID) : this.props.refNum
    )
    .then(this.props.redirectToReceipt)
    .catch(err => {
        this.setState({
          paymentClicked: false,
          nativeError: (
            <React.Fragment>
              {err.errorCode ? <strong>{err.errorCode} -</strong> : null}
              {err.errorMessage || err.message ||
                'Something went wrong while processing this payment. Please try again later.'}
            </React.Fragment>
          )
        })
    })
  }
  togglePaymentClicked = () => {
    this.setState({ paymentClicked: true })
  }
  startPayment = method => {
    this.togglePaymentClicked()
    method()
  }
  bypassPayment = () => {
    BYPASS_PAYMENT(
      PASS_ITEM_GUIDS_ON_CHECKOUT ? 
      {
        ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(container => container.GUID)
      } :
      {
        SECURETOKENID: this.props.refNum
      },
      (refNum) => {
        if (PAYMENT_BYPASS_SIMULATES_PAYPAL_CALLBACK) {
          window.ALLOW_BYPASS_WIZARD_PROMPT = true
          history.push(`/processpayment/paypal?SECURETOKENID=${refNum || this.props.refNum}`)
        } else {
          this.props.redirectToReceipt(refNum)
        }
      },
      err => {
        this.setState({
          prePaymentError: true,
          prePaymentErrorMessage: err.message,
          paymentClicked: false
        })
        console.error(err, 'nice try.')
      }
    )
  }
  payWithFrequentPayor = () => {
    if (PASS_ITEM_GUIDS_ON_CHECKOUT){
      WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR(
        {
          ITEMIDS: this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(container => container.GUID)
        },
        (refNum) => {
          this.props.redirectToReceipt(refNum)
        },
        err => {
          this.setState({
            prePaymentError: true,
            prePaymentErrorMessage: err.message,
            paymentClicked: false
          })
          console.error(err)
        }
      )
    }
    else{
      WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR(
        this.props.refNum,
        () => {
          this.props.redirectToReceipt()
        },
        err => {
          this.setState({
            prePaymentError: true,
            prePaymentErrorMessage: err.message,
            paymentClicked: false
          })
          console.error(err)
        }
      )
    }
  }
  setTransactLoaded = () => this.setState({ iTransactIsLoaded: true })
  registerSubmodule = module =>
    this.setState(state => ({ registeredSubmodules: [...state.registeredSubmodules, module] }))
  removeItemFromCart = guid => {
    const deletedGuids = this.state.deletedGuids
    this.setState(state => ({
      deletedGuids: [...state.deletedGuids, guid]
    }))
    REMOVE_FROM_WEB_CART_BY_GUID(
      guid,
      success => {
        this.props.setCartQuantity(this.getNumReceiptItemContainers())
        if (typeof this.props.onCartRefresh === 'function') {
          this.props.onCartRefresh()
        }
        if (typeof this.props.onReceiptItemContainerRemoved === 'function') {
          this.props.onReceiptItemContainerRemoved(guid)
        }
      },
      err => {
        console.error(err)
        if (typeof this.props.onCartRefresh === 'function') {
          this.props.onCartRefresh()
        }
        else {
          this.setState({ deletedGuids })
        }
      }
    )
  }
  getFilteredReceiptItemContainers = items =>
    items ? items.filter(x => !this.state.deletedGuids.includes(x.GUID)) : []
  getNumReceiptItemContainers = () =>
    this.getFilteredReceiptItemContainers(this.props.receiptItemContainers.filter(x => !x.IS_FREE))
      .length
  setPrepaymentError = prePaymentError => this.setState({ prePaymentError })
  nativeCheckoutCallbackHandler = null
  registerNativeCallbackHandler = handler => {
    if (typeof handler !== 'function') {
      throw new Error('The handler you attempted to register is not a function.')
    } else {
      this.nativeCheckoutCallbackHandler = handler
    }
  }
  handleNativeCallback = values => {
    this.setState({ paymentClicked: true, nativeError: null })
    this.nativeCheckoutCallbackHandler(values)
  }
  render() {
    const {
      receiptItems = [],
      receiptItemContainers: allReceiptItemContainers,
      total: rawTotal = 0,
      onRequestModalClose,
      loading,
      availableMethods,
      methods = [],
      refNum,
      ignoreAvailability,
      isFrequentPayor,
      loggedIn
    } = this.props
    const receiptItemContainers = this.getFilteredReceiptItemContainers(allReceiptItemContainers)
    const hasRenderableItems = allReceiptItemContainers
      ? !!receiptItemContainers.length
      : !!receiptItems.length
    let total = rawTotal
    if (receiptItemContainers.length < (allReceiptItemContainers || []).length) {
      total = calculateReceiptItemContainersTotal(receiptItemContainers)
    }
    const paymentButtonsDisabled = this.state.paymentClicked || this.state.nativeCheckoutActive
    const displayShoppingCart = (SHOPPING_CART === true && loggedIn === true)
    return (
      <div className="checkout" aria-busy={loading}>
        <div className="header">
          <span className="icon icon-cart" />
          <span className="title">{displayShoppingCart ? 'Cart' : 'Checkout'}</span>
          <button
            type="button"
            className={`close ${displayShoppingCart ? 'close-text' : ''}`}
            onClick={!this.state.paymentClicked ? onRequestModalClose : null}
            disabled={this.state.paymentClicked}
          >
            {displayShoppingCart ? 'Close Cart' : <span className="icon icon-cross" />}
          </button>
        </div>
        {
          loading ?
          <Spinner color="#7792d0" className="checkout-loader" size="small" />
          :
          <NativeCheckout
            active={this.state.nativeCheckoutActive}
            disabled={this.state.paymentClicked}
            error={this.state.nativeError}
            processing={this.state.paymentClicked}
            onDeactivateRequested={() => this.setState({ nativeCheckoutActive: false })}
            onSubmit={this.handleNativeCallback}
          >
            <React.Fragment>
              <div className="line-items">
                {allReceiptItemContainers ? (
                  receiptItemContainers.length ? (
                    receiptItemContainers.map((itemContainer, i) =>
                      !itemContainer.IS_FREE ? (
                        <ItemContainer
                          mainItem={itemContainer.RECEIPT_ITEM_WEB_LIST[0]}
                          receiptItems={itemContainer.RECEIPT_ITEM_WEB_LIST.slice(1)}
                          onRemoveRequested={() => this.removeItemFromCart(itemContainer.GUID)}
                          disabled={paymentButtonsDisabled}
                          key={itemContainer.GUID}
                        />
                      ) : null
                    )
                  ) : (
                    <p className="cart-empty-hint">There are no items in your cart</p>
                  )
                ) : receiptItems.length ? (
                  receiptItems.map((item, i) => (
                    <LineItem
                      product={item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR}
                      price={item.LINE_TOTAL.toFixed(2)}
                      key={item.REF_NUM + i}
                    />
                  ))
                ) : (
                  <p className="cart-empty-hint">There are no items in your cart</p>
                )}
              </div>
              {hasRenderableItems ? (
                <div className="subtotals">
                  <SubTotal label="Total:" price={`$${Number(total).toFixed(2)}`} total={true} />
                </div>
              ) : null}
              {this.state.prePaymentErrorMessage && (
                <p className="method-error">{this.state.prePaymentErrorMessage}</p>
              )}
              {hasRenderableItems ? (
                availableMethods !== null ? (
                  methods.map(method => {
                    if (availableMethods[method.type] === true || ignoreAvailability) {
                      switch (method.type) {
                        case 'paypal':
                          return (
                            <form
                              method="POST"
                              action={this.state.paypalParams.PAYMENT_URL}
                              key={method.type + 'frm'}
                            >
                              <input
                                type="hidden"
                                name="SECURETOKENID"
                                value={this.state.paypalParams.SECURETOKENID}
                                readOnly
                              />
                              <input
                                type="hidden"
                                name="SECURETOKEN"
                                value={this.state.paypalParams.SECURETOKEN}
                                readOnly
                              />
                              <input type="hidden" name="ECHODATA" value="user" readOnly />
                              <input
                                type="hidden"
                                name="USER1"
                                value={JSON.stringify({
                                  ORIGIN: BASE_URL,
                                  BASE_URL,
                                  ENV: process.env.NODE_ENV
                                })}
                                readOnly
                              />
                              <PaymentButton
                                onClick={() => {
                                  this.startPayment(this.getPaypalToken)
                                }}
                                disabled={paymentButtonsDisabled}
                                error={this.state.prePaymentError}
                              >
                                Pay with Credit Card
                                {/* <img src={paypal} alt='Pay with Paypal'/> */}
                              </PaymentButton>
                              <button
                                ref={r => {
                                  this.paypalSubmit = r
                                }}
                                style={{ display: 'none' }}
                                type="submit"
                              />
                            </form>
                          )
                        case 'accessIDCC':
                          return (
                            <React.Fragment>
                              <form
                                method="POST"
                                action={this.state.paypalParams.BASEPAYMENTURL}
                                key={method.type + 'frm'}
                              >
                                <PaymentButton
                                  onClick={() => {
                                    this.startPayment(this.getAccessIDCCToken)
                                  }}
                                  disabled={paymentButtonsDisabled}
                                  error={this.state.prePaymentError}
                                >
                                  Pay with Credit Card
                                </PaymentButton>
                                <button
                                  ref={r => {
                                    this.accessIDCCSubmit = r
                                  }}
                                  style={{ display: 'none' }}
                                  type="submit"
                                />
                              </form>
                            </React.Fragment>
                          )
                        case 'accessIDLOC':
                          return (
                            <form
                              method="POST"
                              action={this.state.paypalParams.BASEPAYMENTURL}
                              key={method.type + 'frm'}
                            >
                              <PaymentButton
                                onClick={() => {
                                  this.startPayment(this.getAccessIDLOCToken)
                                }}
                                disabled={paymentButtonsDisabled}
                                error={this.state.prePaymentError}
                              >
                                Pay with Access Idaho
                              </PaymentButton>
                              <button
                                ref={r => {
                                  this.accessIDLOCSubmit = r
                                }}
                                style={{ display: 'none' }}
                                type="submit"
                              />
                            </form>
                          )
                        case 'iTransact':
                          return (
                            <form key="iTransact">
                              <ITransact 
                                refNum={refNum} 
                                onComplete={this.props.redirectToReceipt} 
                                receiptItemGuids={this.getFilteredReceiptItemContainers(this.props.receiptItemContainers).map(container => container.GUID)}
                              />
                            </form>
                          )
                        case 'bypass':
                          return (
                            <PaymentButton
                              onClick={() => {
                                this.startPayment(this.bypassPayment)
                              }}
                              error={this.state.prePaymentError}
                              disabled={paymentButtonsDisabled}
                              key={method.type}
                            >
                              Bypass Checkout (Dev-only)
                            </PaymentButton>
                          )
                        case 'frequentPayor':
                          return isFrequentPayor ? (
                            <FrequentPayorCheckoutSection
                              key={method.type}
                              total={total}
                              disabled={paymentButtonsDisabled}
                              error={this.state.prePaymentError}
                              errorMessage={this.state.prePaymentErrorMessage}
                              onPaymentRequested={() => this.startPayment(this.payWithFrequentPayor)}
                            />
                          ) : null
                        case 'elavon':
                          return (
                            <form key="elavon">
                              {method.method === 'lightbox' ? (
                                <ElavonCheckoutSection
                                  refNum={refNum}
                                  onComplete={this.props.redirectToReceipt}
                                  onPrePaymentError={err => this.setPrepaymentError(err.errorMessage)}
                                  error={this.state.prePaymentError}
                                />
                              ) : null}
                              {method.method === 'checkout' ? (
                                <ElavonProvider method="checkout">
                                  {elavonLoaded => (
                                    <PaymentButton
                                      bypassLoadingStyles
                                      onClick={() => {
                                        this.registerNativeCallbackHandler(this.submitElavonCheckout)
                                        this.setState({ nativeCheckoutActive: true })
                                      }}
                                      disabled={paymentButtonsDisabled || !elavonLoaded}
                                      error={this.state.prePaymentError}
                                    >
                                      Pay with Credit Card
                                    </PaymentButton>
                                  )}
                                </ElavonProvider>
                              ) : null}
                            </form>
                          )
                        default:
                          return (
                            <PaymentButton
                              onClick={() => {
                                this.startPayment(this.bypassPayment)
                              }}
                              disabled={paymentButtonsDisabled}
                              error={this.state.prePaymentError}
                              key={method.type}
                            >
                              Payment (demo)
                            </PaymentButton>
                          )
                      }
                    } else {
                      return availableMethods[method.type] ? (
                        availableMethods[method.type] === 'hide' ? null : (
                          <p className="method-error">{availableMethods[method.type]}</p>
                        )
                      ) : null
                    }
                  })
                ) : (
                  <p className="method-error">
                    There are currently no online payment methods available.
                  </p>
                )
              ) : null}
              {displayShoppingCart && hasRenderableItems ? (
                <div className="flex-row continue-section">
                  <button
                    className="continue-button"
                    disabled={paymentButtonsDisabled}
                    onClick={!this.state.paymentClicked ? onRequestModalClose : null}
                  >
                    <div className="flex-center">
                      <CaretLeftIcon /> File/Order Additional Items
                    </div>
                  </button>
                </div>
              ) : null}
            </React.Fragment>
          </NativeCheckout>
        }
      </div>
    )
  }
}
Checkout = connect(
  state => ({ isFrequentPayor: state.auth.isFrequentPayor, loggedIn: state.auth.loggedIn }),
  {
    setCartQuantity
  }
)(Checkout)

const ItemContainer = ({ mainItem = {}, receiptItems, onRemoveRequested, disabled }) => {
  return (
    <div className="flex-row align-center line-item-container">
      <div className="buttons-wrapper">
        <button
          disabled={disabled}
          className="remove-item-button"
          onClick={onRemoveRequested}
          aria-label={`Remove ${
            mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR
          } from the cart.`}
        >
          <CrossIcon />
        </button>
      </div>
      <div className="flex-column line-item-column">
        <LineItem
          product={mainItem.DESCR_DISPLAY ? mainItem.DESCR_DISPLAY : mainItem.DESCR}
          price={Number(mainItem.LINE_TOTAL).toFixed(2)}
          deletable
        />
        {receiptItems.map((item, i) => (
          <LineItem
            product={item.DESCR_DISPLAY ? item.DESCR_DISPLAY : item.DESCR}
            price={Number(item.LINE_TOTAL).toFixed(2)}
            key={item.REF_NUM + i}
            deletable
            subline
          />
        ))}
      </div>
    </div>
  )
}

const LineItem = ({ product, price, details = [], deletable, subline }) => (
  <div className={`line-item ${subline ? 'subline' : ''}`}>
    <div className="row">
      <div className="col-9">
        <span className={`product ${deletable ? 'deletable' : ''}`}>{product}</span>
        {details.map((detail, i) => (
          <span className="detail" key={i}>
            {detail}
          </span>
        ))}
      </div>
      <div className="col-3">
        <span className="price">${price}</span>
      </div>
    </div>
  </div>
)

const SubTotal = ({ label, price, total }) => (
  <div className={'row subtotal ' + (total ? 'total' : '')}>
    <div className="col-8">
      <span className="label">{label}</span>
    </div>
    <div className="col-4">
      <span className="price">{price}</span>
    </div>
  </div>
)

export class PaymentButton extends Component {
  state = {
    loading: false,
    error: false
  }
  componentWillReceiveProps = nextProps => {
    if (this.state.loading && nextProps.error) {
      this.setState({
        loading: false,
        error: true
      })
    }
  }
  onClick = () => {
    if (!this.props.bypassLoadingStyles) {
      this.setState({
        loading: true,
        error: false
      })
    }
    this.props.onClick()
  }
  render() {
    const { children, disabled, loading, disableErrorHandling, forceShowError, className = '', style } = this.props
    const hasError = forceShowError || this.state.error;
    return (
      <button
        type="button"
        className={`payment-button btn-3d button ${
          hasError && !disableErrorHandling ? 'danger' : ''
        } ${disabled === false ? '' : 'disabled'} ${className}`}
        onClick={this.onClick}
        disabled={disabled || (hasError && !disableErrorHandling)}
        style={style}
        aria-busy={(loading || this.state.loading) && !forceShowError}
      >
        <div className="center">
          {(this.state.loading || loading) && !forceShowError ? (
            <Spinner className="loader" size="small" linear color="currentColor" />
          ) : hasError && !disableErrorHandling ? (
            <CrossIcon />
          ) : (
            <LockIcon />
          )}
          <span className="label">
            {hasError && !disableErrorHandling ? 'Something went wrong' : children}
          </span>
          {
            (loading || this.state.loading) &&
              <span role="alert" className="visually-hidden">"Your payment is processing, please wait."</span>
          }
        </div>
      </button>
    )
  }
}

class ITransact extends React.Component {
  state = {
    loaded: false,
    token: null,
    customer: null,
    allowAddNewPaymentSource: true,
    selectedSource: '',
    deletingPaymentType: false,
    reloadingPayment: false,
    processingPayment: false,
    checkoutButtonText: '',
    modalTitle: '',
    modalDescr: '',
    additionalText: '',
    apiUsername: '',
    achEnabled: false,
    error: null,
    description: null,
    skipStoredPayments: false
  }
  script = null
  componentDidMount = () => {
    let promises = []
    if (!window.iTransact) {
      this.script = document.createElement('script')
      this.script.type = 'text/javascript'
      this.script.src = 'https://js.itransact.com/itransact.js'
      document.head.appendChild(this.script)
      promises.push(
        new Promise((resolve, reject) => {
          this.script.onload = e => {
            resolve()
          }
        })
      )
    }
    promises.push(
      new Promise((resolve, reject) => {
        GET_PAYROC_CUSTOMER(
          customer => {
            // console.log(customer)
            if (customer) {
              this.setState({
                customer,
                selectedSource: customer.payment_sources.length
                  ? customer.payment_sources[0].id
                  : ''
              })
            }
            resolve(customer)
          },
          err => {
            console.error(err)
            reject(err.message)
          }
        )
      })
    )
    promises.push(
      PASS_ITEM_GUIDS_ON_CHECKOUT ?
      new Promise((resolve, reject) => {
        GET_WEB_USER_ACTIVE_CART(
          cart => {
            if (cart) {
              this.setState({
                checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                  ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                  : 'Continue',
                modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                  ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                  : 'Checkout',
                modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                  ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                  : 'Enter billing address and payment information to proceed',
                achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
                additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
                description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
                skipStoredPayments: cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false
              })
            }
            resolve(cart)
          },
          err => {
            console.error(err)
            reject(err.message)
          }
        )
      })
    : new Promise((resolve, reject) => {
      GET_WEB_CART_BY_REF_NUM(
        this.props.refNum,
        cart => {
          if (cart) {
            this.setState({
              checkoutButtonText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                ? cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_BUTTON_TEXT
                : 'Continue',
              modalTitle: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_TITLE
                : 'Checkout',
              modalDescr: cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                ? cart.WEB_CART_ADDITIONAL_PROPS.MODAL_DESCR
                : 'Enter billing address and payment information to proceed',
              achEnabled: cart.WEB_CART_ADDITIONAL_PROPS.ACH_ENABLED_YN,
              additionalText: cart.WEB_CART_ADDITIONAL_PROPS.CHECKOUT_SLIDER_ADDITIONAL_TEXT,
              description: cart.WEB_CART_ADDITIONAL_PROPS.ITRANSACT_DESCRIPTION || null,
              skipStoredPayments: cart.WEB_CART_ADDITIONAL_PROPS.SKIP_STORED_PAYMENTS || false
            })
          }
          resolve(cart)
        },
        err => {
          console.error(err)
          reject(err.message)
        }
      )
    })
    )
    promises.push(
      new Promise((resolve, reject) => {
        GET_APP_SETTING_BY_NAME(
          'PAYROC_API_USERNAME',
          setting => {
            if (setting) {
              this.setState({
                apiUsername: setting.VALUE
              })
            }
            resolve(setting)
          },
          err => {
            console.error(err)
            reject(err.message)
          }
        )
      })
    )
    Promise.all(promises)
      .then(() => {
        this.setState({ loaded: true })
      })
      .catch(err => {
        this.setState({ error: err })
      })
  }
  openItransact = () => {
    if (!this.state.error) this.setState({ error: null })
    const handler = window.iTransact.Checkout.init({
      apiUsername: this.state.apiUsername,
      name: this.state.modalTitle,
      description: this.state.modalDescr,
      panelButtonText: this.state.checkoutButtonText,
      billingAddress: true,
      ach: this.state.achEnabled,
      onToken: (data, args) => {
        this.setState({ token: data.token, reloadingPayment: true })
        CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
          {
            token: data.token,
            address: args
          },
          result => {
            if(this.state.skipStoredPayments){
              this.startTransaction(result.payment_sources[0].id, result.id)
            }else{
              if (result) {
                GET_PAYROC_CUSTOMER(
                  customer => {
                    if (customer) {
                      this.setState({
                        customer,
                        reloadingPayment: false,
                        selectedSource:
                          (customer.payment_sources[customer.payment_sources.length - 1] || {}).id ||
                          ''
                      })
                    }
                  },
                  err => {
                    console.error(err)
                    this.setState({ reloadingPayment: false, error: err.message })
                  }
                )
              }
            }
          }
        )
      }
    })
    handler.render({
      amount: this.props.amount
    })
  }
  startTransaction = (cardId, customerId) => {
    this.setState({ error: null, processingPayment: true });
    CREATE_PAYROC_TRANSACTION(
      {
        id: cardId,
        customerId,
        ITEMIDS: this.props.receiptItemGuids,
        REF_NUM: this.props.refNum
      },
      success => {
        if (success) {
          this.props.onComplete(PASS_ITEM_GUIDS_ON_CHECKOUT ? success : null)
        }
      },
      err => {
        console.error(err)
        this.setState({ error: err.message, processingPayment: false })
      }
    )
  }
  startDelete = id => {
    this.setState({ deletingId: id })
    this.toggleDeleting()
  }
  deletePaymentType = () => {
    DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE(
      this.state.deletingId,
      () => {
        this.setState(state => {
          const index = state.customer.payment_sources.findIndex(s => state.deletingId === s.id)
          return {
            customer: {
              ...state.customer,
              payment_sources: [
                ...state.customer.payment_sources.slice(0, index),
                ...state.customer.payment_sources.slice(index + 1)
              ]
            },
            selectedSource: state.selectedSource === state.deletingId ? '' : state.selectedSource
          }
        })
      },
      err => {
        console.error(err)
        this.setState({ error: err.message })
      }
    )
  }
  toggleDeleting = () => this.setState(s => ({ deletingPaymentType: !s.deletingPaymentType }))
  render() {
    return (
      <div className="itransact-checkout">
        {this.state.loaded ? (
          <React.Fragment>
            {this.state.customer && !this.state.skipStoredPayments && (
              <React.Fragment>
                <p>{this.state.additionalText || 'Select or add a payment method to checkout.'}</p>
                <div className="wizard">
                  <RadioInput
                    value={this.state.selectedSource}
                    onChange={selectedSource => this.setState({ selectedSource })}
                    options={this.state.customer.payment_sources.map(source => ({
                      value: source.id,
                      label:
                        source.type === 'ach' ? (
                          <span className="label-wrapper">
                            <BankIcon />
                            {`${source.savings_account === 'true' ? 'Savings' : 'Checking'} ****${
                              source.last_four_digits
                            }`}
                            <button
                              className="trash-button"
                              type="button"
                              onClick={() => this.startDelete(source.id)}
                              disabled={this.state.processingPayment}
                            >
                              <TrashIcon />
                            </button>
                          </span>
                        ) : (
                          <span className="label-wrapper">
                            <CreditCardIcon />
                            {`${source.brand.charAt(0).toUpperCase() + source.brand.slice(1)} ****${
                              source.last_four_digits
                            }`}
                            <button
                              className="trash-button"
                              type="button"
                              onClick={() => this.startDelete(source.id)}
                              disabled={this.state.processingPayment}
                            >
                              <TrashIcon />
                            </button>
                          </span>
                        )
                    }))}
                  />
                </div>
              </React.Fragment>
            )}
            {
              !this.state.skipStoredPayments &&
              <button
                type="button"
                className="new-payment-btn"
                disabled={this.state.reloadingPayment || this.state.processingPayment}
                onClick={this.openItransact}
              >
                <div className="flex-center">
                  {this.state.reloadingPayment ? (
                    <React.Fragment>
                      <Spinner size="small" color="rgba(255,255,255,.6)" /> Adding Payment Method
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <PlusIcon /> Add New Payment Method
                    </React.Fragment>
                  )}
                </div>
              </button>
            }
            {this.state.error && (
              <p className="payment-error" role="alert">
                <CrossIcon /> <span>{this.state.error}</span>
              </p>
            )}
            {(this.state.selectedSource || this.state.skipStoredPayments) && (
              <PaymentButton
                onClick={() => this.state.skipStoredPayments ? this.openItransact() : this.startTransaction(this.state.selectedSource)}
                disabled={
                  !this.state.loaded || (!this.state.selectedSource && !this.state.skipStoredPayments) || this.state.processingPayment
                }
                error={this.state.prePaymentError}
                disableErrorHandling={true}
                bypassLoadingStyles={true}
                loading={this.state.processingPayment}
              >
                Checkout
              </PaymentButton>
            )}
            {this.state.description && (
              <ReactMarkdown source={this.state.description} className="markdown cart-description" />
            )}
            {CHECKOUT_DISCLAIMER && (
              <ReactMarkdown source={CHECKOUT_DISCLAIMER} className="markdown" />
            )}
          </React.Fragment>
        ) : (
          <Spinner color="#7792d0" className="checkout-loader" size="small" />
        )}
        <Portal isOpened={this.state.deletingPaymentType}>
          <ConfirmDialog
            closeModal={this.toggleDeleting}
            onModalClosed={() => {}}
            message="Are you sure you want to delete this payment method? Any active subscriptions using this payment method will be canceled. This cannot be undone."
            buttons={[
              { label: 'No', onClick: () => {}, className: 'btn-default' },
              {
                label: 'Yes',
                onClick: this.deletePaymentType,
                className: 'btn-danger'
              }
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Checkout/Checkout.js